import { PostJobFormAttributes, TransformedFormData } from 'Douleutaras/redux/data/jobs/types';
import { POST_JOB_FLOW } from 'Douleutaras/views/job/post-job/types';

export const transformFormDataToJobAttributes = (formData: Partial<TransformedFormData>): Partial<PostJobFormAttributes> => {
  const questions = {};

  // Transform questions
  if (formData.attributes.details?.values !== undefined && Array.isArray(formData.attributes.details.values)) {
    formData.attributes.details?.values?.forEach((value => {
      questions[value.attribute] = value.value;
    }));
  }

  return {
    address: formData.attributes.location,
    categoryFormId: formData.attributes.categoryForm?.id,
    questions,
    marketing: typeof formData.attributes.consents?.find(consent => consent.type === 'marketing') !== undefined,
    name: formData.attributes.buyer_fullname,
    email: formData.attributes.buyer_email,
    phone: formData.attributes.buyer_phone,
    location: formData.attributes.location,
    proId: formData.attributes.pro_id
  };
};

// Transforms our form into a Payload our API can read
export const transformJobAttributesToFormData = ({
    flow,
    formData,
    gclid,
    cookieConsents
  }: {
    flow: POST_JOB_FLOW;
    formData: Partial<PostJobFormAttributes>;
    gclid: string;
    cookieConsents: { [key: string]: string };
  }): TransformedFormData => {
  const data: TransformedFormData = {
    type: '',
    attributes: {
      details: {
        values: []
      },
      buyer_email: formData.email,
      categoryForm: {
        type: 'categoryForm',
        id: formData.categoryFormId // categoryFormId
      },
      consents: [
        {
          type: 'terms_and_conditions',
          text: ''
        }
      ],
      location: formData.location,
      referrer_id: formData.referrerId
    }
  };

  if (formData.autoDealIds && [ POST_JOB_FLOW.SINGLE_BID, POST_JOB_FLOW.MULTI_BID,
      POST_JOB_FLOW.FASTLANE_SINGLE, POST_JOB_FLOW.FASTLANE_MULTI ].includes(flow)) {
    data.attributes.autoDealsIds = formData.autoDealIds;
  } else if (formData.proId) {
    data.attributes.pro_id = formData.proId;
  }

  if (formData.name) {
    data.attributes.buyer_fullname = formData.name;
  }

  if (formData.phone) {
    data.attributes.buyer_phone = formData.phone;
  }

  if (formData.questions && Object.keys(formData.questions).length > 0) {
    data.attributes.details.values = Object.keys(formData.questions)
      .map(questionId => {
        const questionValue = formData.questions[questionId];

        // Multi-select questions
        if (Array.isArray(questionValue)) {
          return {
            attribute: parseInt(questionId, 0),
            value: questionValue.map(value => parseInt(value, 0))
          };
        }

        // Single selection
        return {
          attribute: parseInt(questionId, 0),
          value: questionValue
        };
      });
  }

  switch (flow) {
    // FAST_LANE, LEGACY, LEGACY_FALLBACK etc
    default:
      data.attributes.sub_posting_flow = 'auto';
      break;
    case POST_JOB_FLOW.DIRECT_CONTACT:
    case POST_JOB_FLOW.MULTI_BID:
    case POST_JOB_FLOW.SINGLE_BID:
      data.attributes.sub_posting_flow = 'manual';
      break;
  }

  if (gclid) {
    data.attributes.gclid = gclid;
  }

  if (Object.keys(cookieConsents).length > 0) {
    data.attributes.cookie_consents = cookieConsents;
  }

  // tslint:disable-next-line:no-null-keyword
  data.attributes.experiment_key = null;
  // tslint:disable-next-line:no-null-keyword
  data.attributes.experiment_value = null;

  if (formData.marketing) {
    data.attributes.consents.push({
      type: 'marketing',
      text: ''
    });
  }

  return data;
};
